const SnortIcon = ({ color = "var(--border)", width = 24, height = 24 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 24 24"
      width={width}
      height={height}>
      <path
        fill={color}
        d="m14,16.5c0,.813-.916,1.5-2,1.5s-2-.687-2-1.5.916-1.5,2-1.5,2,.687,2,1.5Zm9-3.5c0,6.065-4.935,11-11,11S1,19.065,1,13,5.935,2,12,2s11,4.935,11,11Zm-14.5-1c.828,0,1.5-.672,1.5-1.5s-.672-1.5-1.5-1.5-1.5.672-1.5,1.5.672,1.5,1.5,1.5Zm7.5,4.5c0-1.93-1.794-3.5-4-3.5s-4,1.57-4,3.5,1.794,3.5,4,3.5,4-1.57,4-3.5Zm1-6c0-.828-.672-1.5-1.5-1.5s-1.5.672-1.5,1.5.672,1.5,1.5,1.5,1.5-.672,1.5-1.5ZM.961,6.132C2.433,3.77,4.642,1.915,7.266.889,5.805.167,4.15.047,2.621.013,1.882-.001,1.145.311.649.877.161,1.437-.053,2.179.062,2.913c.09.573.327,1.757.898,3.219Zm22.096.028c.471-1.138.809-2.264.965-3.247.115-.735-.1-1.477-.589-2.036-.495-.566-1.213-.881-1.97-.864-1.558.035-3.241.156-4.72.88,2.63,1.031,4.843,2.895,6.314,5.267Z"
      />
    </svg>
  );
};

export default SnortIcon;
